export default [
  {
    path: "/app/settings",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Configurações",
      requiresAuth: true,
    },
    children: [
      /* User Type */
      {
        path: "test",
        name: "test",
        component: () => import("../user-type/test.vue"),
      },
      {
        path: "user-type",
        name: "settings.user-type",
        component: () => import("../user-type/views/List.vue"),
        meta: {
          permission: "view_user_type",
        },
      },
      {
        path: "user-type/create",
        name: "settings.user-type.create",
        component: () => import("../user-type/views/Create.vue"),
        meta: {
          permission: "view_user_type",
        },
      },
      {
        path: "user-type/create/:id",
        name: "settings.user-type.edit",
        component: () => import("../user-type/views/Edit.vue"),
        meta: {
          permission: "view_user_type",
        },
      },
      /* Params */
      {
        path: "params",
        name: "settings.params",
        component: () => import("../params/views/List.vue"),
        meta: {
          permission: "view_user_type",
        },
      },
      /* AI */
      {
        path: "ai",
        name: "settings.ai",
        component: () => import("../ai/index.vue"),
        meta: {
          permission: "view_ai_settings",
        },
      },
      {
        path: "auditing/logs",
        name: "settings.auditing.logs",
        component: () => import("../auditing/views/Logs.vue"),
        meta: {
          permission: "view_audit_log",
        },
      },
      /* Users */
      {
        path: "users",
        name: "settings.users",
        component: () => import("../users/views/List.vue"),
        meta: {
          permission: "view_settings_users",
        },
      },
      {
        path: "users/create",
        name: "settings.users.create",
        component: () => import("../users/views/Create.vue"),
        meta: {
          permission: "view_settings_users",
        },
      },
      {
        path: "users/edit/:id",
        name: "settings.users.edit",
        component: () => import("../users/views/Edit.vue"),
        meta: {
          permission: "view_settings_users",
        },
      },
      {
        path: "users/show/:id",
        name: "settings.users.show",
        component: () => import("../users/views/Show.vue"),
        meta: {
          permission: "view_settings_users",
        },
      },
      /* Bncc */
      {
        path: "bncc",
        name: "settings.bncc",
        component: () => import("../../settings/bncc/views/List.vue"),
        meta: {
          permission: "view_bncc",
        },
      },
      {
        path: "bncc/create",
        name: "settings.bncc.create",
        component: () => import("../../settings/bncc/views/CreateSimple.vue"),
        meta: {
          permission: "view_bncc",
        },
      },
      {
        path: "bncc/edit-simple/:id",
        name: "settings.bncc.edit-simple",
        component: () => import("../../settings/bncc/views/EditSimple.vue"),
        meta: {
          permission: "view_bncc",
        },
      },
      {
        path: "bncc/edit/:id",
        name: "settings.bncc.edit",
        component: () => import("../../settings/bncc/views/Edit.vue"),
        meta: {
          permission: "view_bncc",
        },
      },
      {
        path: "bncc/show/:id",
        name: "settings.bncc.show",
        component: () => import("../../settings/bncc/views/Show.vue"),
        meta: {
          permission: "view_bncc",
        },
      },
      {
        path: "bncc/add-many",
        name: "settings.bncc.add-many",
        component: () => import("../../settings/bncc/views/AddMany.vue"),
        meta: {
          permission: "view_bncc",
        },
      },
      /* Tool Maintenance */
      {
        path: "tools",
        name: "settings.tools-maintenance",
        component: () => import("../tools-maintenance/views/List.vue"),
        meta: {
          permissions: ["view_update_situation_registration_batch",
            "view_update_registries",
            "view_update_stages_group",
            "view_update_entry_date",
            "view_enrollment_maintenance"
          ],
          mode: "any"
        },
      }
    ],
  },
];
